export default __webpack_public_path__ + "static/media/extra_out_l3.2b1005f3.svg";